<template>
  <Modal :title="title" class="table-list sub-order large">
    <template v-slot:body>
      <div class="d-flex align-items-start">
        <TableList :config="configTable()"></TableList>
      </div>
    </template>
  </Modal>
</template>

<script>
import TableList from './../TableList.vue'
export default {
  components: {
    TableList
  },
  computed: {
    title() {
      return 'Sub Orders'
    },
    storeId() {
      return this.config?.storeId
    },
    orderId() {
      return this.config?.data?._id
    }
  },
  methods: {
    configTable() {
      return {
        preload: true,
        showTableFilters: true,
        tableId: 'sub-order',
        indexUri: `sub-order/${this.orderId}`,
        storeId: ['sub-order'],
        isSubOrder: true,
        isSubTable: true,
        disabledRenderScreenOptions: true
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.table-list.sub-order {
  .modal-footer {
    display: none;
  }
}
</style>
